<template>
  <v-container>
    <v-layout wrap>
      <v-flex xs12>
        <h1 class="display-1 mb-5">Four virtuel</h1>
      </v-flex>
    </v-layout>

    <v-layout row wrap>
      <v-flex xs4 class="pl-3 pr-3">
        <v-text-field v-model="authKey" label="Auth key" outline :disabled="connected"></v-text-field>
      </v-flex>

      <v-flex xs2 class="pl-3 pr-3">
        <v-btn
          v-if="!connected"
          color="blue"
          @click="initSocket(true)"
          dark
          small
          block
        >Connexion + auth</v-btn>
        <v-btn v-if="!connected" color="blue" @click="initSocket()" dark small block>Connexion</v-btn>

        <v-btn v-else small color="blue" @click="closeConnexion()" dark block>Déconnection</v-btn>
      </v-flex>
      <v-flex xs4>
        État de connexion :
        <b>{{ connexionState }}</b>
      </v-flex>
    </v-layout>

    <br>
    <v-layout row wrap>
      <v-flex xs2>
        <v-text-field v-model="veille" label="Veille"></v-text-field>
      </v-flex>
      <v-flex xs2>
        <v-text-field v-model="marche" label="Marche"></v-text-field>
      </v-flex>
      <v-flex xs2>
        <v-text-field v-model="auto" label="Auto"></v-text-field>
      </v-flex>
      <v-flex xs2>
        <v-text-field v-model="mode" label="Mode"></v-text-field>
      </v-flex>
      <v-flex xs2>
        <v-text-field v-model="ventilation" label="Ventilation"></v-text-field>
      </v-flex>

      <v-flex xs2>
        <v-text-field v-model="pas" label="Pas"></v-text-field>
      </v-flex>
      <v-flex xs2>
        <v-text-field v-model="estime" label="Estime"></v-text-field>
      </v-flex>

      <v-flex xs2>
        <v-text-field v-model="duration" label="Durée"></v-text-field>
      </v-flex>
      <v-flex xs2>
        <v-text-field v-model="timer" label="Timer"></v-text-field>
      </v-flex>
      <v-flex xs2>
        <v-text-field v-model="total" label="Total"></v-text-field>
      </v-flex>
      <v-flex xs2>
        <v-text-field v-model="consigne" label="Consigne"></v-text-field>
      </v-flex>
      <v-flex xs2>
        <v-text-field v-model="temperature" label="Température"></v-text-field>
      </v-flex>
      <v-flex xs2>
        <v-text-field v-model="humidite" label="Humidité"></v-text-field>
      </v-flex>

      <v-flex xs4 class="pl-5 pr-5">
        <v-btn color="primary" @click="sendData()" block>Envoyer les données</v-btn>
      </v-flex>
    </v-layout>

    <br>
    <v-layout row wrap>
      <v-flex xs6>
        <v-text-field v-model="recipeNumber" label="Recette (numéro)"></v-text-field>
      </v-flex>
      <v-flex xs6>
        <v-text-field v-model="recipeName" label="Recette (nom)"></v-text-field>
      </v-flex>
    </v-layout>
    <br>

    <v-layout row wrap>
      <v-flex xs4>
        <b>
          Envoyer un message spécifique
          <em>(valider avec ENTRÉE)</em>
        </b>

        <v-text-field
          v-model="message"
          label="Message"
          v-on:keyup.enter="sendMessageButton"
          :disabled="!connected"
        ></v-text-field>
      </v-flex>
    </v-layout>
  </v-container>
</template>


<script>
import config from "../config";

const PATH_OVEN = "/oven";

export default {
  data: () => ({
    socket: null,
    message: "",
    connected: false,
    connexionState: "CLOSE",
    authKey: "test",
    //
    veille: 0,
    marche: 0,
    auto: 0,
    mode: 1,
    ventilation: 0,
    pas: 0,
    estime: 0,
    duration: 0,
    timer: 0,
    total: 0,
    consigne: 0,
    temperature: 0,
    humidite: 0,
    recipeNumber: 2,
    recipeName: "Pomme au four"
  }),
  computed: {},
  methods: {
    checkReady() {
      window.alert(this.socket.readyState);
    },

    // envoyer les données
    sendData() {
      var dataArray = [
        this.veille,
        this.marche,
        this.auto,
        this.mode,
        this.ventilation,
        this.pas,
        this.estime,
        this.total,
        this.duration,
        this.timer,
        this.consigne,
        this.temperature,
        this.humidite
      ];

      this.sendKeyValue("data", dataArray.join(" "));
    },

    // envoi via socket
    send(message) {
      if (this.socket) {
        console.log("socket ->", message);
        this.socket.send(message);
      }
    },

    // envoi d'une pair de valeurs
    sendKeyValue(key, value) {
      this.send(key + " " + value);
    },

    _newCommand(command, firstData, dataArray) {
      console.log("RECEPTION", command, firstData, dataArray);

      switch (command) {
        case "veille":
          this.veille = firstData;
          break;

        case "mode":
          this.mode = firstData;
          break;

        case "marche":
          this.marche = firstData;
          break;

        case "consigne":
          this.consigne = firstData;
          break;

        case "duration":
          this.duration = firstData;
          break;

        case "ventilation":
          this.ventilation = firstData;
          break;

        case "recette":
          this._sendRecipe();
          break;
      }

      // envoi des données
      this.sendData();
    },

    // initialisation du socket
    initSocket(autoAuth = false) {
      console.log("création du socket");

      var protocole = "ws";
      if (config.secure) {
        protocole = "wss";
      }

      var socket = new WebSocket(
        protocole + "://" + config.server_domain + PATH_OVEN
      );

      this.socket = socket;

      socket.onopen = event => {
        var vm = this;
        vm.connexionState = "OPEN";
        vm.connected = true;
        // Lorsque la connexion se termine.
        socket.onclose = function(event) {
          vm.connexionState = "CLOSE";
          vm.connected = false;
          console.log("Connexion terminée...");
        };

        socket.onerror = function(event) {
          vm.connexionState = "ERROR";
          vm.connected = false;
          console.log("Connexion erreur...");
        };

        // Lorsque le serveur envoi un message.
        socket.onmessage = event => {
          console.log("socket <-", event.data);

          if (event.data == "connected") {
            // envoi les données
            this.sendData();
          } else {
            // parse
            var dataArray = event.data.split(" ");
            this._newCommand(dataArray.shift(), dataArray[0], dataArray);
          }
        };

        //  envoi du message d'authentification
        if (autoAuth) {
          console.log("Authentification...");
          this.sendKeyValue("auth", this.authKey);
        }
      };
    },

    closeConnexion() {
      if (this.socket) {
        this.socket.close();
        this.socket = null;
      }
    },

    sendMessageButton() {
      if (this.message) {
        this.send(this.message);
        this.message = null;
      }
    },

    _sendRecipe() {
      var recipeNameFormated = this.recipeName.split(" ").join("+");

      var message = "recette " + this.recipeNumber + " " + recipeNameFormated;
      this.send(message);
    }
  },
  mounted() {
    // this.initSocket();
  }
};
</script>


<style>
</style>
